import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2, GripVertical } from "lucide-react";

let _tluid = 0;
const withKey = (o) => ({ ...o, _k: o._k ?? `tl${++_tluid}` });

export default function TimelineEditor() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/kv/timeline").then(({ data }) => Array.isArray(data) && setItems(data.map(withKey)));
  }, []);

  const upd = (i, k, v) => setItems((arr) => { const a = [...arr]; a[i] = { ...a[i], [k]: v }; return a; });
  const add = () => setItems((arr) => [...arr, withKey({ year: new Date().getFullYear(), event: "" })]);
  const remove = (i) => setItems((arr) => arr.filter((_, j) => j !== i));
  const move = (i, dir) => setItems((arr) => {
    const j = i + dir;
    if (j < 0 || j >= arr.length) return arr;
    const a = [...arr]; [a[i], a[j]] = [a[j], a[i]]; return a;
  });
  const sortByYear = () => setItems((arr) => [...arr].sort((a, b) => Number(a.year) - Number(b.year)));

  const save = async () => {
    setSaving(true);
    try {
      const cleaned = items
        .filter((t) => t.year || t.event)
        .map((t) => ({ year: Number(t.year) || t.year, event: t.event || "" }));
      await api.put("/content/kv/timeline", { value: cleaned });
      toast.success("Linha do tempo atualizada.");
    } catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-6 flex-wrap gap-3">
        <div>
          <h1 className="font-display text-4xl">Linha do Tempo</h1>
          <p className="text-sm text-neutral-500 mt-1">Marcos da Places — aparece na seção &ldquo;Não chegamos ontem&rdquo; da home.</p>
        </div>
        <div className="flex gap-2">
          <button onClick={sortByYear} className="text-xs border border-black/15 px-3 py-1.5 rounded-full hover:bg-black/5" data-testid="timeline-sort">Ordenar por ano</button>
          <button onClick={save} disabled={saving} data-testid="timeline-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> {saving ? "Salvando…" : "Salvar"}</button>
        </div>
      </div>

      <section className="border border-black/10 p-5 rounded">
        <div className="flex justify-between items-center mb-4">
          <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700">Marcos ({items.length})</div>
          <button onClick={add} className="text-xs bg-accent-yellow px-3 py-1 rounded-full font-semibold" data-testid="timeline-add"><Plus className="w-3 h-3 inline" /> Adicionar marco</button>
        </div>
        <div className="space-y-2">
          {items.map((t, i) => (
            <div key={t._k || `idx-${i}`} className="grid grid-cols-12 gap-2 items-center" data-testid={`timeline-${i}`}>
              <div className="col-span-1 flex flex-col items-center">
                <button onClick={() => move(i, -1)} className="text-neutral-400 hover:text-black"><GripVertical className="w-3 h-3" /></button>
                <span className="text-[10px] font-mono text-neutral-400">{i + 1}</span>
              </div>
              <input value={t.year ?? ""} onChange={(e) => upd(i, "year", e.target.value)} placeholder="Ano" type="number" className="col-span-2 border border-black/15 px-3 py-2 rounded text-sm font-mono" />
              <input value={t.event || ""} onChange={(e) => upd(i, "event", e.target.value)} placeholder="Marco (ex.: 'Fundação da agência em Goiânia')" className="col-span-8 border border-black/15 px-3 py-2 rounded text-sm" />
              <button onClick={() => remove(i)} className="col-span-1 text-red-500 justify-self-center"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
          {!items.length && <div className="text-xs text-neutral-500 text-center py-6">Nenhum marco cadastrado.</div>}
        </div>
      </section>
    </div>
  );
}
